const SortIcon = ({ sortDirection = "default" }: { sortDirection?: "asc" | "desc" | "default" }) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.666687" width="20" height="20" rx="2" fill="#F3F4F6" />
      <g clipPath="url(#clip0_7_19123)">
        <path
          d="M8.57165 14.4415L8.57739 14.4357C8.68042 14.3327 8.83244 14.3538 8.89256 14.4215C8.97758 14.5171 8.97791 14.6645 8.8838 14.7614L6.31316 17.1823L6.31306 17.1822L6.30599 17.1893C6.29454 17.2007 6.27423 17.2148 6.2449 17.226C6.21544 17.2372 6.18682 17.2417 6.16669 17.2417C6.14656 17.2417 6.11795 17.2372 6.08848 17.226C6.05915 17.2148 6.03884 17.2007 6.02739 17.1893L6.02747 17.1892L6.02134 17.1834L3.4999 14.7868C3.38805 14.6727 3.40201 14.5361 3.47739 14.4607L3.24169 14.225L3.47739 14.4607C3.59195 14.3462 3.73005 14.3598 3.80599 14.4357L3.80592 14.4358L3.81181 14.4414L5.38681 15.9414L5.95003 16.4778V15.7V3C5.95003 2.8591 6.05079 2.75834 6.19169 2.75834C6.32329 2.75834 6.43336 2.87465 6.43336 3V15.7V16.4778L6.99658 15.9414L8.57158 14.4414L8.57165 14.4415Z"
          fill="#9CA3AF"
          stroke={sortDirection === "asc" ? "black" : "#9CA3AF"}
          strokeWidth="0.666667"
        />
        <path
          d="M18.0417 5L15.5167 2.6C15.2917 2.4 14.9667 2.4 14.7417 2.6L12.2167 5C11.9917 5.225 11.9917 5.575 12.1917 5.8C12.2917 5.925 12.4417 5.975 12.5917 5.975C12.7417 5.975 12.8667 5.925 12.9667 5.825L14.5417 4.325V17C14.5417 17.3 14.7917 17.575 15.1167 17.575C15.4417 17.575 15.6917 17.325 15.6917 17V4.3L17.2667 5.8C17.4917 6.025 17.8417 6 18.0667 5.775C18.2917 5.55 18.2667 5.2 18.0417 5Z"
          fill={sortDirection === "desc" ? "black" : "#9CA3AF"}
        />
      </g>
      <defs>
        <clipPath id="clip0_7_19123">
          <rect width="16" height="16" fill="white" transform="translate(2.66669 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortIcon;
